import React from "react";
import {
  Button,
  Card,
  Grid,
  CardActions,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import Icon from "@mui/material/Icon";
import { makeStyles } from "@mui/styles";
import BG_IMG from "../../../assets/images/announcement-card-bg.png";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { CardHeading, ViewMoreButton, DashboardCard } from "../Common";
import moment from "moment";

const useStyles = makeStyles({
  cardMain: {
    // backgroundImage: `url(${BG_IMG})`,
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: 'cover',
    padding: 3,
    backgroundColor: "#06623B !important",
    // height: 340,
    // width: 750,
  },
  cardHeading: {
    color: "white",
    marginBottom: "6px !important",
    // fontSize: "0.9em !important",
    // fontWeight: '700',
  },
  cardBody: {
    color: "#FFF",
    // fontSize: "0.85em !important",
    fontWeight: "600",
    marginBottom: "6px !important",
  },
  cardDate: {
    color: "#FFF",
    fontSize: "12px !important",
    // fontSize: "0.85em !important",
    fontWeight: "400",
    marginBottom: "6px !important",
  },
  datetext: {
    color: "#FFF",
    // fontWeight: '400',
    fontWeight: 100,
    opacity: 0.8,
  },
});

function AnnouncementsCard(props) {
  const classes = useStyles();

  const announcementData = props.announcementData;
  const announcementText = announcementData?.body;
  const createdAt = moment(announcementData?.createdAt).format("D MMMM YYYY");

  return (
    <DashboardCard
      moreButtonText="View More"
      moreButtonColor="alternate"
      innerCardBG="#06623B"
      showMoreButton={true}
      innerCardContentNoPadding={true}
      viewMoreButtonNoPaddingTop={true}
      innerCardHorizontalPadding="16px"
      onViewMoreClick={() => props.setOpen(!props.open)}
    >
      <Box sx={{ my: "10px" }}>
        <CardHeading text="Announcement" color="alternate" />
      </Box>

      <Box>
        <Typography className={classes.cardBody} variant="body2" paragraph>
          {announcementText}
        </Typography>
        <Typography className={classes.cardDate} variant="body2" paragraph>
          {createdAt}
        </Typography>
      </Box>
    </DashboardCard>
  );
}

export default AnnouncementsCard;
